import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { Field } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import * as validate from 'utils/validate';

import orderLineTypes from 'config/orderLineTypes';

const ProductClaimTypeFields = ({ name, ...fields, disabled, onFieldFocus, onFieldBlur }) => {
  const ID = get(fields, `${name}.ID`);
  return (
    <Field
      id={`${name}.Type`}
      name={`${name}.Type`}
      label="Type"
      component={AutosuggestField}
      validate={[validate.required]}
      placeholder="-Select-"
      fullWidth
      labelOverlap
      renderSuggestionContent={suggestion => suggestion}
      onSuggestionSelected={(suggestion) => {
        onFieldBlur({
          Type: suggestion,
        });
        return suggestion;
      }}
      fetchSuggestions={({ value, offset }) => (new Promise((resolve) => {
        if (offset === 0) {
          if (value.length > 0) {
            resolve(orderLineTypes
              .filter(item => item.toLowerCase().indexOf(value.toLowerCase()) !== -1));
          } else {
            resolve(orderLineTypes);
          }
        } else {
          resolve([]);
        }
      }))}
      onFocus={event => onFieldFocus({
        Type: event.target.value,
      })}
      onBlur={(event) => {
        if (event.target.value) {
          onFieldBlur({
            Type: event.target.value,
          });
        }
      }}
      disabled={disabled}
    />
  );
};

ProductClaimTypeFields.propTypes = {
  name: PropTypes.string.isRequired,
  onFieldFocus: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ProductClaimTypeFields.defaultProps = {
  disabled: false,
};

export default ProductClaimTypeFields;



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimTypeFields.js